

//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EtablissementModel } from '../models/EtablissementModel';
import { EtablissementSiteForListModel } from '../models/EtablissementSiteForListModel';
import { EtablissementSiteModel } from '../models/EtablissementSiteModel';
import { EtablissementEmailModel } from '../models/EtablissementEmailModel';
import { EtablissementSiteIndicateurEditModel } from '../models/EtablissementSiteIndicateurEditModel';
import { EtablissementSiteIndicateurModel } from '../models/EtablissementSiteIndicateurModel';

@Injectable({
   providedIn: 'root'
})
export class EtablissementApiService {
    constructor(private _httpClient: HttpClient) { }        
    
    // get: api/Etablissement/getEtablissementsAvecIndicateur
    getEtablissementsAvecIndicateur(): Observable<EtablissementModel[]> {
        var _Url = `api/Etablissement/getEtablissementsAvecIndicateur`;
            return this._httpClient.get<EtablissementModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Etablissement/getEtablissementSitesAvecIndicateur
    getEtablissementSitesAvecIndicateur(): Observable<EtablissementSiteForListModel[]> {
        var _Url = `api/Etablissement/getEtablissementSitesAvecIndicateur`;
            return this._httpClient.get<EtablissementSiteForListModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Etablissement/getEtablissements
    getEtablissements(): Observable<EtablissementModel[]> {
        var _Url = `api/Etablissement/getEtablissements`;
            return this._httpClient.get<EtablissementModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Etablissement/getEtablissementsForIndicateur?indicateurId=${indicateurId}
    getEtablissementsForIndicateur(indicateurId: number): Observable<EtablissementModel[]> {
        var _Url = `api/Etablissement/getEtablissementsForIndicateur?indicateurId=${indicateurId}`;
            return this._httpClient.get<EtablissementModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Etablissement/getEtablissementSitesForIndicateur?indicateurId=${indicateurId}
    getEtablissementSitesForIndicateur(indicateurId: number): Observable<EtablissementSiteForListModel[]> {
        var _Url = `api/Etablissement/getEtablissementSitesForIndicateur?indicateurId=${indicateurId}`;
            return this._httpClient.get<EtablissementSiteForListModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Etablissement/getEtablissementsSites
    getEtablissementsSites(): Observable<EtablissementSiteModel[]> {
        var _Url = `api/Etablissement/getEtablissementsSites`;
            return this._httpClient.get<EtablissementSiteModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Etablissement/getEtablissementEmails
    getEtablissementEmails(): Observable<EtablissementEmailModel[]> {
        var _Url = `api/Etablissement/getEtablissementEmails`;
            return this._httpClient.get<EtablissementEmailModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Etablissement/saveEtablissementEmail
    saveEtablissementEmail(etablissementEmail: EtablissementEmailModel): Observable<EtablissementEmailModel> {
        var _Url = `api/Etablissement/saveEtablissementEmail`;
            return this._httpClient.post<EtablissementEmailModel>(_Url, etablissementEmail).pipe(catchError(this.handleError));
    }
    
    // post: api/Etablissement/deleteEtablissementEmail?id=${id}
    deleteEtablissementEmail(id: number): Observable<boolean> {
        var _Url = `api/Etablissement/deleteEtablissementEmail?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // get: api/Etablissement/getEtablissementsSiteIndicateurEdit
    getEtablissementsSiteIndicateurEdit(): Observable<EtablissementSiteIndicateurEditModel[]> {
        var _Url = `api/Etablissement/getEtablissementsSiteIndicateurEdit`;
            return this._httpClient.get<EtablissementSiteIndicateurEditModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Etablissement/getEtablissementsSiteIndicateur
    getEtablissementsSiteIndicateur(): Observable<EtablissementSiteIndicateurModel[]> {
        var _Url = `api/Etablissement/getEtablissementsSiteIndicateur`;
            return this._httpClient.get<EtablissementSiteIndicateurModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Etablissement/saveEtablissementSiteIndicateur
    saveEtablissementSiteIndicateur(etablissementSiteIndicateur: EtablissementSiteIndicateurEditModel): Observable<EtablissementSiteIndicateurEditModel> {
        var _Url = `api/Etablissement/saveEtablissementSiteIndicateur`;
            return this._httpClient.post<EtablissementSiteIndicateurEditModel>(_Url, etablissementSiteIndicateur).pipe(catchError(this.handleError));
    }
    
    // post: api/Etablissement/delete?id=${id}
    delete(id: number): Observable<boolean> {
        var _Url = `api/Etablissement/delete?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // post: api/Etablissement/save
    save(etablissementModel: EtablissementModel): Observable<EtablissementModel> {
        var _Url = `api/Etablissement/save`;
            return this._httpClient.post<EtablissementModel>(_Url, etablissementModel).pipe(catchError(this.handleError));
    }
    
    // Utility
    private handleError(error: HttpErrorResponse) {
        console.error(error);
        let customError: string = "";
        if (error.error) {
            customError = error.status === 400 ? error.error : error.statusText
        }
        return throwError(customError || 'Server error');
    }
}
